import $ from 'jquery';

const defaults = {
  instanceSelector: '[data-tabs]',
  tabSelector: 'data-tab-id',
  panelSelector: 'data-panel-id',
  tabsToggle: '.c-zva-tabs__toggle',
  tabIsActiveClass: 'c-zva-tabs__toggle--is-active',
  tabIsDisabledClass: 'c-zva-tabs__toggle--is-disabled',
  panelIsActiveClass: 'o-panel--is-active',
};

const init = (opts) => {
  const config = { ...defaults, ...opts };
  const $instances = $(config.instanceSelector);

  $instances.each((index, tab) => {
    const $tabs = $(tab);
    $tabs.on('click', config.tabsToggle, (event) => {
      let $clickedTab = $(event.target);

      if (!$clickedTab.attr(config.tabSelector)) {
        $clickedTab = $clickedTab.parent();
      }

      if ($clickedTab.hasClass(config.tabIsDisabledClass)) {
        event.preventDefault();
        return false;
      }

      const tabId = $clickedTab.attr(config.tabSelector);
      const $content = $tabs.next(); // assume next element in dom is content
      const $allTabs = $tabs.find(`[${config.tabSelector}]`);
      const $allPanels = $content.find(`[${config.panelSelector}]`);
      const $selectedPanel = $content.find(`[${config.panelSelector}=${tabId}]`);

      $allTabs.removeClass(config.tabIsActiveClass);
      $clickedTab.addClass(config.tabIsActiveClass);
      $allPanels.removeClass(config.panelIsActiveClass);
      $selectedPanel.addClass(config.panelIsActiveClass);

      return true;
    });
  });
};

export default {
  init
};



// WEBPACK FOOTER //
// ./modules/tabs.js